import React from 'react';
import { displayDate, displayDateTime } from '@iso/lib/helpers/utility';
import { Page, Document, StyleSheet, Text, View } from '@react-pdf/renderer';

let employeLogoDimensions = [170,65];
let image = sessionStorage.getItem('employeLogo');

if(image !== null && typeof image !== 'undefined')
    employeLogoDimensions = sessionStorage.getItem('employeLogoDimensions').split('x');

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 9,
        paddingTop: 30,
        paddingLeft:30,
        paddingRight:30,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
      marginLeft: '0',
      width: employeLogoDimensions[0], 
      height: employeLogoDimensions[1],
        // marginRight: 'auto'
    },
    pageTitleContainer: {
        flexDirection: 'row',
        marginTop: 5,
        width: '100%',
        justifyContent: 'center'
    },
    bold:{
        fontWeight: 'bold',
        fontFamily: 'Helvetica-Bold',
    },
    reportTitle:{
        fontSize: 9,
        marginTop: 5,
        textIndent:'5px',
        fontFamily: 'Helvetica-Bold'
    },
    fragmentContainer: {
        width: '100%',
        padding:'2px',
        borderRadius:'3px',
        flexDirection: 'row',
        border: '1px solid #000000'
    },
    tableContainer: {
        fontSize: 8
    },
    text: {
        fontSize: 8
    }
});

const PeopleMergeLog = ({data}) => {

    let peopleArray = {}, usersArray = {};

    data.people.forEach(element => {
        peopleArray[element._id] = element;
    });

    data.users.forEach(element => {
        usersArray[element._id] = element;
    });

    return (
        <Document debug={true}>
            <Page size="A4" style={styles.page} orientation={'portrait'} wrap={true}>

                <View render={({ pageNumber, totalPages }) => (
                    <View style={{width:'100%', flexDirection: 'row', marginBottom:'10px'}}>
                        <Text style={{width:'33%', fontSize:8}}>{displayDate()}</Text>
                        <Text style={{width:'33%', fontSize:8, textAlign:'center'}}>{`Página ${pageNumber} / ${totalPages}`}</Text>
                        <Text style={{width:'34%', fontSize:8, textAlign:'right'}}>{data.title}</Text>
                    </View>
                )} fixed/>

                <View style={{...styles.pageTitleContainer, ...{marginBottom:'5px'}}}>
                    <Text style={styles.pageTitle}>{`Período: ${displayDate(data.filter_data.data_inicio)} à ${displayDate(data.filter_data.data_final)}`}</Text>
                </View>
                {
                    data.merges.length > 0 ?
                    <>
                        <View style={styles.tableContainer}>
                            {data.merges.map(item => {
                                return (
                                    (typeof item._id !== 'undefined') ?
                                        <View style={{ border:'1px #000 solid', marginBottom:'5px' }} key={item._id}>
                                            <View style={{ flexDirection: 'row', borderBottom: '1px #000 solid', padding: '2px' }}>
                                                <Text style={{width:'33%', fontSize:8}}>
                                                    <Text style={styles.bold}>Cliente principal</Text>: {peopleArray[item.masterId]['name']}
                                                </Text>
                                                <Text style={{width:'33%', fontSize:8, textAlign:'center'}}>
                                                    <Text style={styles.bold}>Usuário</Text>: {usersArray[item.user]['name']}
                                                </Text>
                                                <Text style={{width:'33%', fontSize:8, textAlign:'right'}}>
                                                    <Text style={styles.bold}>Quando</Text>: {displayDateTime(item.createdAt)}
                                                </Text>
                                            </View>
                                            <View style={{ flexDirection: 'row', width:'100%', fontSize:8, padding: '2px'}}>
                                                <Text style={{...styles.bold, ...{marginRight:'5px'}}}>Agrupados:</Text>
                                                {
                                                    item.clients.map(p => {
                                                        return ( (p !== item.masterId) ?
                                                            <Text>
                                                                {peopleArray[p]['name']}, 
                                                            </Text>
                                                            : <></>
                                                        )
                                                    })
                                                }
                                            </View>
                                        </View>
                                        : ''
                                )})}
                        </View>
                    </>
                    :
                    <View key={"container"} style={styles.fragmentContainer}>
                        <Text key={'address'} style={styles.label}>Sem registros...</Text>
                    </View>
                } 
            </Page>
        </Document>
    )
};
  
export default PeopleMergeLog